import {useEffect, useMemo, useRef} from 'react';
import {useSyncExternalStore} from 'use-sync-external-store/shim';
import {Conversation} from '@stripe-internal/conversations-client';
import {ConversationPoller, PollFn} from '../lib/ConversationPoller';

export function useConversationPoller(
  poll: PollFn,
  conversation: Conversation,
) {
  const pollRef = useRef(poll);
  pollRef.current = poll;

  const poller = useMemo(
    () => new ConversationPoller(() => pollRef.current(), conversation),
    [conversation],
  );

  useEffect(() => () => poller.destroy(), [poller]);

  const state = useSyncExternalStore(
    (callback) => poller.subscribe(callback),
    () => poller.getState(),
  );

  useEffect(() => {
    poller.startPolling();
    return () => poller.stopPolling();
  }, [poller]);

  return state;
}
